import React, { useContext, useEffect, useState } from 'react';
import ResourceDetailTabs from '../Shared/ResourceDetail/ResourceDetailTabs';
import { FormContextProvider } from '@stormwater-software/lib-form';
import { SettingsTab } from './SettingTabs';
import InspectionIntervals from './InspectionIntervals';
import { RolesContext } from '../../contexts/RolesContext';
import { ProjectTypes } from './ProjectType';
import { RegionComponent } from './Region';
import { AllFeatures } from './Features/AllFeatures';
import UploadCompanyLogo from './UploadCompanyLogo';
import tenantApi from '../../utils/api/tenant';
import AppContext from '../../contexts/AppContext';
import SubscriptionTab from './Subscription/SubscriptionTab';
import TenantInspectionDetails from './TenantInspectionDetails';
import { TooltipContextProvider } from '@stormwater-software/lib-ui';
import BillingDetails from './BillingDetails';
import AreaSettings from './AreaSettings';
import Security from './Security';
import AuthorizationAgreementSettings from './AuthorizationAgreementSettings';
import PDFEditting from './PDFEditting';
import SiteMapVersionLock from './SiteMapVersionLock';
import ProjectDocuments from './ProjectDocuments';
import BillingAddons from './BillingAddons';
import HubspotApiTab from './HubspotApi/HubspotApiTab';

export default function Administration() {
  const [isWhiteLabel, setIsWhiteLabel] = useState(false);
  const appStore = useContext(AppContext);
  const permCheck = useContext(RolesContext).userHasPermission;
  const userCanEdit = permCheck('all', 'Administration Features');

  const user = appStore.get('user');

  useEffect(() => {
    tenantApi.features
      .index(user.tenantId, 'white_label')
      .then((res) => {
        if (res && res[0]) {
          setIsWhiteLabel(res[0].is_enabled);
        }
      })
      .catch((e) => console.log(e));
  }, []);

  return (
    <>
      {userCanEdit ? (
        <ResourceDetailTabs
          headers={[
            'Settings',
            'Subscription',
            'Features',
            'Billing Details',
            'HubSpot API'
          ]}
          panels={[
            () => (
              <FormContextProvider>
                <SettingsTab />
                {isWhiteLabel && <UploadCompanyLogo />}
                <TooltipContextProvider>
                  <TenantInspectionDetails />
                </TooltipContextProvider>
                <InspectionIntervals />
                <BillingAddons />
                <ProjectTypes />
                <AreaSettings />
                <RegionComponent />
                <ProjectDocuments />
                <PDFEditting />
                <SiteMapVersionLock />
                <AuthorizationAgreementSettings />
                <Security />
              </FormContextProvider>
            ),
            () => (
              <FormContextProvider>
                <SubscriptionTab role={user.userTenantRoles[0].role} />
              </FormContextProvider>
            ),
            () => (
              <FormContextProvider>
                <AllFeatures setIsWhiteLabel={setIsWhiteLabel} />
              </FormContextProvider>
            ),
            () => (
              <BillingDetails />
            ),
            () => <HubspotApiTab />,
          ]}
          showTab={true}
        />
      ) : (
        <ResourceDetailTabs
          headers={['Settings', 'Subscription', 'HubSpot API']}
          panels={[
            () => (
              <FormContextProvider>
                <SettingsTab />
                <TooltipContextProvider>
                  <TenantInspectionDetails />
                </TooltipContextProvider>
                <InspectionIntervals />
                <BillingAddons />
                <ProjectTypes />
                <AreaSettings />
                <RegionComponent />
                <ProjectDocuments />
                <PDFEditting />
                <SiteMapVersionLock />
                <AuthorizationAgreementSettings />
                <Security />
              </FormContextProvider>
            ),
            () => (
              <FormContextProvider>
                <SubscriptionTab role={user.userTenantRoles[0].role} />
              </FormContextProvider>
            ),
            () => <HubspotApiTab />,
          ]}
          showTab={true}
        />
      )}
    </>
  );
}
